import createFetchDuck from '../../util/genericEntityDuck';

export const storeKey = 'serviceAccounts';
const duck = createFetchDuck('HEARTBEAT', storeKey, 'serviceAccountId', 'heartbeat');

export default duck;
export const { creators, reducer, types, selectors } = duck;
